<template>
  <v-row dense>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/training"
        block
      >
        培訓報名
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/tasklist"
        block
      >
        工作列表
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/eleave"
        block
      >
        年假
      </v-btn>
    </v-col>
    <!--
      <v-col
        cols="12"
        md="4"
      >
        <v-btn
          to="/marrySubsidy"
          block
        >
          結婚津貼
        </v-btn>
      </v-col>
       -->
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/subsidy"
        block
      >
        申請津貼
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/humanResources"
        block
      >
        人力資源資料
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/contact/StaffEntityOfficial"
        block
      >
        部門 / 附屬單位負責人
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/box/GeneralOpinion"
        block
      >
        意見
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/redirect/attendance?type=attendanceSelf"
        block
      >
        出勤
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/attendance/OT"
        block
      >
        超時工作
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/workflow/List"
        block
      >
        進度
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/BDRH/Index"
        block
      >
        BDRH
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/Outbox"
        block
      >
        Outbox
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/eSign"
        block
      >
        eSign
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/tools/index"
        block
      >
        輔助工具
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/test/idVerification"
        block
      >
        身份驗證
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/mapa/"
        block
      >
        MAPA
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-btn
        to="/mapa/ViewStaff"
        block
      >
        MAPA 主管
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({ })
}
</script>
